import React, { useState } from "react";
import T from "prop-types";
import { useCurrentUser } from "APP_ROOT/hooks";
import { hasAnyOfSubroles } from "MODULES/users/helpers";
import {
  CREATE_COMMERCIAL_INVOICE,
  WAREHOUSE_EXPERT,
  WAREHOUSE_LOGISTICS_DIRECTOR
} from "MODULES/users/constants";
import { Icon } from "MODULES/shared/components";
import { Modal } from "./Modal";
import DropDownItem from "../../../../../shared/components/DropDown/DropDownItem";

function CreateCommercialInvoice({ salesOrder }) {
  const [visible, setVisible] = useState(false);
  const user = useCurrentUser();

  if (
    !hasAnyOfSubroles(user, [
      CREATE_COMMERCIAL_INVOICE,
      WAREHOUSE_LOGISTICS_DIRECTOR,
      WAREHOUSE_EXPERT
    ])
  ) {
    return null;
  }

  return (
    <DropDownItem onClick={() => setVisible(true)}>
      <Icon name="refresh" fixed />
      &nbsp;Create Commercial Invoice
      <Modal
        salesOrder={salesOrder}
        outbound={false}
        open={visible}
        close={() => setVisible(false)}
      />
    </DropDownItem>
  );
}

export default CreateCommercialInvoice;

CreateCommercialInvoice.propTypes = {
  shipment: T.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Actions/CreateCommercialInvoice/CreateCommercialInvoice.jsx